const createNavSlice = (set) => ({

   activeView: 1, //network
   updateActiveView: (newView) => {
      set({ activeView: newView })
   },
});

export default createNavSlice;
